import { render } from "./ArticlesItem.vue?vue&type=template&id=ad605c32"
import script from "./ArticlesItem.vue?vue&type=script&lang=js"
export * from "./ArticlesItem.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__